import { Component, Inject, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { SpecialModule } from 'lib/modules/special.module';
import { CmsPartialComponentClass } from 'lib/components/cms/cms-partial-component.class';
import { RouterService } from 'lib/services/router.service';
import { WebpService } from 'lib/services/webp.service';
import { CategoryService } from 'lib/services/category/category.service';

@Component({
    selector: 'cms-partial-category-top-paragraph',
    templateUrl: './paragraph.component.html',
    styleUrls: ['./paragraph.component.scss'],
    standalone: true,
    imports: [CommonModule, SpecialModule],
    encapsulation: ViewEncapsulation.None,
})
export class ParagraphComponent extends CmsPartialComponentClass {
    @Input() paragraphRow: any;
    @Input() grayBackgroundRows: any = [];
    getWebpImg: (src: string) => string;

    constructor(
        @Inject('environment') environment: any,
        routerService: RouterService,
        webpService: WebpService,
        location: Location,
        categoryService: CategoryService
    ) {
        super({
            dependencies: {
                environment,
                routerService,
                location,
                categoryService,
            },
        });
        this.getWebpImg = (src: string) => webpService.getWebpImg(src);
    }
}
